import { format } from 'date-fns';
import { toInt } from 'lib/utils/number';

export const toDate = (date: Date | string) => {
  if (date instanceof Date) {
    return date;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})(T)?/.exec(date);

  if (!match) {
    return new Date('invalid_date');
  }

  const [, year, month, day, includesTime] = match;

  if (includesTime) {
    return new Date(date);
  }

  // Note: must be passed as `new Date(year, month, day)` as safari assumes UTC for calendar date strings
  return new Date(toInt(year), toInt(month) - 1, toInt(day));
};

export const toDisplayDateFormat = (date: Date | string) => {
  const dateInstance = toDate(date);
  return format(dateInstance, 'E dd MMM, yyyy');
};

export const toDisplayDateOnlyFormat = (date: Date | string) => {
  const dateInstance = toDate(date);
  return format(dateInstance, 'dd MMM, yyyy');
};

export const toCalendarDateFormat = (date: Date | string) => {
  const dateInstance = toDate(date);
  return format(dateInstance, 'yyyy-MM-dd');
};
